import React, { useEffect } from "react";
import { useForm, FormContextInterface } from "../context";
import { Box, Typography, Button } from "@mui/material";
import { Done } from "@mui/icons-material";

const SchoolDetails = () => {
  const { schoolInfo, stepChange, activeStep, handleSubmitLogActivity } =
    useForm() as FormContextInterface;

  useEffect(() => {
    const getElementById = document.getElementById("school-button");

    if (getElementById) {
      getElementById.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "end",
      });
    }
  }, []);
  const schoolContinue = () => {
    handleSubmitLogActivity({
      ActivityType: "SchoolContinueButton",
    });
  };
  return (
    <Box>
      <Typography
        dangerouslySetInnerHTML={{ __html: schoolInfo?.quote }}
        style={{ textAlign: "justify" }}
      ></Typography>
      <Box justifyContent={"center"} display="flex">
        {schoolInfo?.schoolSignUp == true ? (
          <Button
            variant="contained"
            id="school-button"
            onClick={() => {
              stepChange("studentDetails");
              schoolContinue();
            }}
            sx={{
              mt: 3,
              background: "#ff00d0",
              borderRadius: "10px",
              fontWeight: "bold",
            }}
          >
            {activeStep.studentDetails ? <Done /> : "Continue"}
          </Button>
        ) : (
          ""
        )}
      </Box>
    </Box>
  );
};

export { SchoolDetails };
